import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

interface ProcedureCardProps {
  item: {
    value: string;
    display: string;
    code: string;
    serviceCost?: number;
  };
  index: number;
  onEdit: (item: any, index: number) => void;
  onDelete: (index: number) => void;
}

export function ProcedureCard({
  item,
  index,
  onEdit,
  onDelete,
}: ProcedureCardProps) {
  return (
    <Card
      sx={{
        width: "100%",
        border: "1px solid",
        borderColor: "neutral300.main",
        borderRadius: "8px",
        overflow: "visible",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.05)",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <CardContent sx={{ p: 3, pb: 2 }}>
        <Stack spacing={2}>
          <Box>
            <Typography
              variant="body2"
              color="neutral700.main"
              sx={{ mb: 0.5 }}
            >
              Procedimento
            </Typography>
            <Typography
              variant="body1"
              fontWeight="500"
              color="neutral1000.main"
              sx={{
                overflow: "hidden",
                maxHeight: "40px",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                lineHeight: 1.3,
                textWrap: "nowrap",
              }}
            >
              {item.display}
            </Typography>
          </Box>

          <Divider sx={{ mx: -3, mb: 2 }} />
          <Stack direction="row" spacing={2} justifyContent="space-between">
            <Box>
              <Typography
                variant="body2"
                color="neutral700.main"
                sx={{ mb: 0.5 }}
              >
                Valor
              </Typography>
              <Typography
                variant="subtitle2"
                color="primary.main"
                fontWeight="bold"
              >
                {item.serviceCost?.toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Box>
            <Box>
              <Typography
                variant="body2"
                color="neutral700.main"
                sx={{ mb: 0.5 }}
              >
                Código
              </Typography>
              <Typography
                variant="subtitle2"
                fontWeight="500"
                color="neutral1000.main"
                sx={{
                  fontFamily: "monospace",
                  backgroundColor: "neutral100.main",
                  borderRadius: 1,
                  display: "inline-block",
                }}
              >
                {item.code}
              </Typography>
            </Box>
          </Stack>

          <Divider sx={{ mx: -3 }} />
        </Stack>
        <Divider sx={{ width: "100%" }} />
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            size="small"
            variant="outlined"
            color="primary"
            startIcon={<EditIcon fontSize="small" />}
            onClick={() => onEdit(item, index)}
            sx={{
              textTransform: "none",
              fontSize: "0.75rem",
              py: 0.5,
              minWidth: 0,
            }}
          >
            Editar
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="error"
            startIcon={<DeleteIcon fontSize="small" />}
            onClick={() => onDelete(index)}
            sx={{
              textTransform: "none",
              fontSize: "0.75rem",
              py: 0.5,
              minWidth: 0,
            }}
          >
            Excluir
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
